import { errorToast } from '@/toast';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

/**
 * Redirects to a fallback route with an error toast when an entity is not found.
 */
export const useRedirectIfNotFound = (notFound: boolean, path: string, message: string) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (notFound) {
            errorToast(message);
            void navigate(path, { replace: true });
        }
    }, [notFound, navigate, message, path]);
};
